import { Link } from "react-router-dom";
import { Instagram, Facebook, Phone, Mail, MapPin } from "lucide-react";
import { useSite } from "@/lib/site-context";
import PikiLogo from "./PikiLogo";

export default function Footer() {
  const { site } = useSite();
  const s = site || {};

  return (
    <footer className="bg-[#050505] border-t border-[#2E2E2E]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <Link to="/" className="inline-block mb-5">
            <PikiLogo className="h-24 w-auto" />
          </Link>
          <p className="text-sm text-[#A3A3A3] leading-relaxed" data-testid="footer-description">
            Simple, reliable car rentals across Auckland. Clean vehicles, transparent pricing and friendly local service.
          </p>
        </div>

        <div>
          <div className="font-display font-bold text-white mb-4 text-sm tracking-widest">EXPLORE</div>
          <ul className="space-y-2 text-sm text-[#A3A3A3]">
            <li><Link to="/" className="hover:text-[#D9A62E]">Home</Link></li>
            <li><Link to="/fleet" className="hover:text-[#D9A62E]">Our Fleet</Link></li>
            <li><Link to="/rates" className="hover:text-[#D9A62E]">Rates</Link></li>
            <li><Link to="/book" className="hover:text-[#D9A62E]">Book a Car</Link></li>
            <li><Link to="/faq" className="hover:text-[#D9A62E]">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-[#D9A62E]">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-display font-bold text-white mb-4 text-sm tracking-widest">LEGAL</div>
          <ul className="space-y-2 text-sm text-[#A3A3A3]">
            <li><Link to="/faq" className="hover:text-[#D9A62E]">Terms &amp; Conditions</Link></li>
            <li><Link to="/faq" className="hover:text-[#D9A62E]">Privacy Policy</Link></li>
            <li><Link to="/faq" className="hover:text-[#D9A62E]">Rental Terms</Link></li>
          </ul>
        </div>

        <div>
          <div className="font-display font-bold text-white mb-4 text-sm tracking-widest">CONTACT</div>
          <ul className="space-y-3 text-sm text-[#A3A3A3]">
            <li className="flex items-start gap-2" data-testid="footer-phone">
              <Phone className="w-4 h-4 text-[#D9A62E] mt-0.5 shrink-0" />
              <span>{s.phone || "Add phone number in admin panel"}</span>
            </li>
            <li className="flex items-start gap-2" data-testid="footer-email">
              <Mail className="w-4 h-4 text-[#D9A62E] mt-0.5 shrink-0" />
              <span>{s.email || "admin@pikicarrentals.co.nz"}</span>
            </li>
            <li className="flex items-start gap-2" data-testid="footer-address">
              <MapPin className="w-4 h-4 text-[#D9A62E] mt-0.5 shrink-0" />
              <span>{s.address || "Add business location in admin panel"}</span>
            </li>
          </ul>
          <div className="flex items-center gap-3 mt-5">
            <a
              href={s.social?.instagram || "#"}
              aria-label="Instagram"
              className="w-9 h-9 rounded-lg border border-[#2E2E2E] flex items-center justify-center hover:border-[#D9A62E] hover:text-[#D9A62E] text-[#A3A3A3]"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a
              href={s.social?.facebook || "#"}
              aria-label="Facebook"
              className="w-9 h-9 rounded-lg border border-[#2E2E2E] flex items-center justify-center hover:border-[#D9A62E] hover:text-[#D9A62E] text-[#A3A3A3]"
            >
              <Facebook className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#2E2E2E] py-6 pb-24 md:pb-6 text-center text-xs text-[#737373]" data-testid="footer-copyright">
        © 2026 Piki Car Rentals. All Rights Reserved.
      </div>
    </footer>
  );
}
